import { showAlert } from '../../services/alert';
import { useAppDispatch } from '../../storeHook';

export const useAlertHelper = () => {
  const dispatch = useAppDispatch();
  return {
    showError: (message: string) =>
      dispatch(
        showAlert({
          content: message,
          severity: 'error',
        })
      ),
  };
};
